import { createSlice } from "@reduxjs/toolkit";

const initialAreaState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  areaForEdit: undefined,
  roleMaster: [],
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const areaSlice = createSlice({
  name: "area",
  initialState: initialAreaState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getAreaById
    areaFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.areaForEdit = action.payload.areaForEdit;
    },
    // findArea
    areasFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    roleMasterFetched: (state, action) => {
      state.actionsLoading = false;
      state.roleMaster = action.payload.roleMaster;
      state.error = null;
    },

    // Set to default state actionLoading & error
    areaReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
